import { Button } from 'rebass';
import { Field, Form } from 'formik';
import { useRect } from '@reach/rect';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import styled from '@emotion/styled';

import CoverField from '../../../app/form/formik/cover';
import Radio from '../../../app/form/formik/radio';
import DateField from '../../../app/form/formik/date';

import TextField from '../../../app/form/formik/text';
import { getGenderOptions } from './options';
import { label } from 'babys-first-year/Step3';

const StyledForm = styled(Form)`
  display: grid;
  grid-gap: 8px;
`;

const CollectionFormBody = ({ isSubmitting, isValid, collection, isFromTft }) => {
  const ref = useRef();
  const rect = useRect(ref);

  return (
    <div ref={ref}>
      <StyledForm>
        <Field
          name="cover"
          component={CoverField}
          currentCover={collection['subject-avatar'] && collection['subject-avatar'].id}
          width={150}
          circular
        />
        <Field
          component={TextField}
          name="first-name-noac"
          label={label('First Name', isFromTft ? true : false)}
          showError
          width="100%"
          mt={2}
        />
        <Field
          component={TextField}
          name="last-name-noac"
          label="Last Name"
          showError
          width="100%"
          mt={2}
        />
        <Field
          component={DateField}
          name="date-of-birth"
          label={label('Birthday', isFromTft ? true : false)}
          placeholder="Birthday"
          width="100%"
          mt={2}
          menuPlacement="top"
        />
        <Field
          component={Radio}
          name="gender"
          label={label('Baby is a...', isFromTft ? true : false)}
          placeholder="Gender"
          options={getGenderOptions('child-journals', isFromTft)}
          my={1}
        />
        <Button type="submit" width="max-content" backgroundColor="#9B59B6" disabled={!isValid || isSubmitting} style={{
          margin: 'auto', color: '#fff', borderRadius: '99px',
          position: 'absolute',
          top: '15px',
          right: '5px',
        }}>
          Save
        </Button>
      </StyledForm>
    </div>
  );
};

CollectionFormBody.propTypes = {
  isValid: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  collection: PropTypes.shape({}),
  type: PropTypes.string.isRequired,
};

CollectionFormBody.defaultProps = {
  collection: {},
};

export default CollectionFormBody;
